// extracted by mini-css-extract-plugin
export default {"container":"Ep-z","brandName":"Fp-z","productName":"Gp-z","productNamePdpEnhancements":"Hp-z","breakLongProductName":"Ip-z"};